import React from 'react'
import Home from './screens/Home'
import Connect from 'screens/Connect'

const publicRoutes = [
  {
    path: '/',
    element: <Home />,
    title: '',
  },
  {
    path: '/connect',
    element: <Connect />,
    title: '',
  }
]

export { publicRoutes }
